// extracted by mini-css-extract-plugin
module.exports = {"Container":"Spinner_Container__Bosyd","Spinner":"Spinner_Spinner__2gVyW","big":"Spinner_big__2BBW-","spin-fast":"Spinner_spin-fast__wu5s2","small":"Spinner_small__2rsFc"};